import React from 'react';
import { getIn18Text } from 'api';
import cloneDeep from 'lodash/cloneDeep';
export const TypesMap = {
    invalid: {
        label: getIn18Text('YICHANG(WUXIAO)'),
        value: 'invalid',
        id: -1,
        type: 1,
    },
    invalidReply: {
        label: '对方明确表示不愿接收',
        value: 'invalidReply',
        id: 34,
        type: 1,
        priority: 1,
    },
    reject: {
        label: '对方拒信',
        value: 'reject',
        id: 35,
        type: 1,
        priority: 1,
    },
    overQuota: {
        label: '对方收件箱已满',
        value: 'overQuota',
        id: 36,
        type: 1,
        priority: 1,
    },
    notFount: {
        label: '收件人地址错误或不存在',
        value: 'notFount',
        id: 37,
        type: 1,
        priority: 1,
    },
    abuse: {
        label: '收件人投诉',
        value: 'abuse',
        id: 38,
        type: 1,
        priority: 1,
    },
    other: {
        label: '此收件人无法发送营销信',
        value: 'other',
        id: 39,
        type: 1,
        priority: 1,
    },
    invalidReply2: {
        label: '对方明确表示不愿接收',
        value: 'invalidReply',
        id: 28,
        type: 1,
        priority: 1,
    },
    reject2: {
        label: '对方拒信',
        value: 'reject',
        id: 29,
        type: 1,
        priority: 1,
    },
    overQuota2: {
        label: '对方收件箱已满',
        value: 'overQuota',
        id: 30,
        type: 1,
        priority: 1,
    },
    notFount2: {
        label: '收件人地址错误或不存在',
        value: 'notFount',
        id: 31,
        type: 1,
        priority: 1,
    },
    abuse2: {
        label: '收件人投诉',
        value: 'abuse',
        id: 32,
        type: 1,
        priority: 1,
    },
    other2: {
        label: '此收件人无法发送营销信',
        value: 'other',
        id: 33,
        type: 1,
        priority: 1,
    },
    hasReturn: {
        label: getIn18Text('CENGJUXIN'),
        value: 'hasReturn',
        id: 13,
        type: 1,
        priority: 5,
    },
    emailUnknown: {
        label: getIn18Text('CHANGQIBUHUOYUE'),
        value: 'emailUnknown',
        id: 102,
        type: 2,
        priority: 8,
    },
    governmentOrgans: {
        label: getIn18Text('DANGZHENGJIGUAN'),
        value: 'governmentOrgans',
        id: 107,
        type: 2,
        priority: 9,
    },
    enterpriseMailbox: {
        label: getIn18Text('QIYEGONGGONGYOUXIANG'),
        value: 'enterpriseMailbox',
        id: 106,
        type: 2,
        priority: 10,
    },
    academicInstitution: {
        label: getIn18Text('XUESHUJIGOU'),
        value: 'academicInstitution',
        id: 108,
        type: 2,
        priority: 11,
    },
    sendIn24h: {
        label: getIn18Text('24XIAOSHINEIFASONG'),
        value: 'sendIn24h',
        id: 5,
        type: 2,
        priority: 12,
    },
    sendIn72h: {
        label: getIn18Text('72XIAOSHINEIFASONG'),
        value: 'sendIn72h',
        id: 6,
        type: 2,
        priority: 13,
    },
    colleagueCustomer: {
        label: getIn18Text('TONGSHIKEHU'),
        value: 'colleagueCustomer',
        id: 8,
        type: 2,
        priority: 14,
    },
    colleagueClue: {
        label: getIn18Text('TONGSHIXIANSUO'),
        value: 'colleagueClue',
        id: 9,
        type: 2,
        priority: 15,
    },
    myCustomer: {
        label: getIn18Text('WODEKEHU'),
        value: 'myCustomer',
        id: 15,
        type: 3,
        priority: 20,
    },
    myClue: {
        label: getIn18Text('WODEXIANSUO'),
        value: 'myClue',
        id: 16,
        type: 3,
        priority: 21,
    },
    hasReply: {
        label: getIn18Text('HUIFUGUO'),
        value: 'hasReply',
        id: 10,
        type: 2,
        priority: 16,
    },
    sendIn1Week: {
        label: getIn18Text('YIZHOUNEIFASONGGUO'),
        value: 'sendIn1Week',
        id: 11,
        type: 3,
        priority: 17,
    },
    sendIn1Month: {
        label: getIn18Text('YIGEYUENEIFASONGGUO'),
        value: 'sendIn1Month',
        id: 12,
        type: 3,
        priority: 18,
    },
    hasSend: {
        label: getIn18Text('SONGDAGUO'),
        value: 'hasSend',
        id: 14,
        type: 3,
        priority: 19,
    },
    blacklist: {
        label: getIn18Text('HEIMINGDAN'),
        value: 'blacklist',
        id: 4,
        type: 1,
        priority: 3,
    },
    colleagueSendIn24h: {
        label: getIn18Text('TONGSHI2XSNFSG'),
        value: 'colleagueSendIn24h',
        id: 24,
        type: 1,
        priority: 22,
    },
    colleagueSendIn72h: {
        label: getIn18Text('TONGSHI7XSNFSG'),
        value: 'colleagueSendIn72h',
        id: 25,
        type: 1,
        priority: 23,
    },
    colleagueHasReply: {
        label: getIn18Text('TONGSHIHUIFG'),
        value: 'colleagueHasReply',
        id: 23,
        type: 1,
        priority: 24,
    },
    colleagueSendIn1Week: {
        label: getIn18Text('TONGSHIYIZNFSG'),
        value: 'colleagueSendIn1Week',
        id: 26,
        type: 1,
        priority: 25,
    },
    colleagueSendIn1Month: {
        label: getIn18Text('TONGSHIYIGYNFSG'),
        value: 'colleagueSendIn1Month',
        id: 27,
        type: 1,
        priority: 26,
    },
    colleagueHasSend: {
        label: getIn18Text('TONGSHISONGDG'),
        value: 'colleagueHasSend',
        id: 22,
        type: 1,
        priority: 27,
    },
};
export const InvalidStatusMap = {
    2: {
        label: getIn18Text('WUXIAODEZHI：ZENGTUI'),
        value: 'revert',
        id: 2,
        type: 1,
        priority: 4,
    },
    3: {
        label: getIn18Text('WUXIAODEZHI：DEZHI'),
        value: 'invalid',
        id: 3,
        type: 1,
        priority: 1,
    },
    4: {
        label: getIn18Text('HEIMINGDAN'),
        value: 'blacklist',
        id: 4,
        type: 1,
        priority: 3,
    },
    7: {
        label: getIn18Text('WUXIAODEZHI：DUIFANG'),
        value: 'sendLimit',
        id: 7,
        type: 1,
    },
    17: {
        label: getIn18Text('QIANGZHIQINGCHUHEIMINGDANBU'),
        value: 'forceBlacklist',
        id: 17,
        type: 1,
        priority: 1,
    },
    18: {
        label: getIn18Text('CUOWUYOUXIANGDIZHIBUKE'),
        value: 'errorAddresslist',
        id: 18,
        type: 1,
        priority: 1,
    },
    19: {
        label: getIn18Text('GUANLIYUANSZTSKHFCTG1'),
        id: 19,
        value: 'forceColleaugeCustomerList',
        type: 1,
        priority: 1,
    },
    20: {
        label: getIn18Text('GUANLIYUANSZTSXSFCTG1'),
        id: 20,
        value: 'forceColleaugeClueList',
        type: 1,
        priority: 1,
    },
    100: {
        label: getIn18Text('WUXIAODEZHI：DEZHI'),
        value: 'invalid',
        id: 100,
        type: 1,
        priority: 1,
    },
    103: {
        label: getIn18Text('WUXIAODEZHI：YUMING'),
        value: 'emailDomainError',
        id: 103,
        type: 1,
        priority: 2,
    },
    104: {
        label: getIn18Text('WUXIAODEZHI：DUIFANG'),
        value: 'emailSendLimit',
        id: 104,
        type: 1,
        priority: 6,
    },
    105: {
        label: getIn18Text('WUXIAODEZHI：TONGYU'),
        value: 'emailSameDomain',
        id: 105,
        type: 1,
        priority: 7,
    },
};
export const errorContactStatusList = [
    {
        value: 1.5,
        label: getIn18Text('KENENGWUXIAO'),
    },
    {
        value: 3,
        label: getIn18Text('GESHICUOWU'),
    },
    {
        value: 4,
        label: getIn18Text('HEIMINGDAN'),
    },
    {
        value: 7,
        label: getIn18Text('FAXINPINLVXIANZHI'),
    },
];
export const warningContactStatusList = [
    {
        value: 5,
        label: getIn18Text('24XIAOSHINEIYIFASONG'),
    },
    {
        value: 6,
        label: getIn18Text('72XIAOSHINEIYIFASONG'),
    },
    {
        value: 8,
        label: getIn18Text('TONGSHIKEHU'),
    },
    {
        value: 9,
        label: getIn18Text('TONGSHIXIANSUO'),
    },
    {
        value: 11,
        label: getIn18Text('YIZHOUNEICHUDAGUO'),
    },
    {
        value: 12,
        label: getIn18Text('YIYUENEICHUDAGUO'),
    },
    {
        value: 13,
        label: getIn18Text('CENGJUXIN'),
    },
    {
        value: 10,
        label: getIn18Text('HUIFUGUO'),
    },
    {
        value: 14,
        label: getIn18Text('SONGDAGUO'),
    },
];
export const myPromiseAll = (arr, limit = 3) => {
    return new Promise((resolve, reject) => {
        let count = 0;
        const n = arr.length;
        const res = new Array(n);
        let index = 0;
        function step(i) {
            if (count === n) {
                resolve(res);
                return;
            }
            if (arr[index]) {
                arr[index]
                    .then(result => {
                    res[i] = result;
                    count++;
                    step(index);
                })
                    .catch(err => {
                    reject(err);
                });
            }
            index++;
        }
        for (let i = 0; i < limit; i++) {
            step(i);
        }
    });
};
export const splitList = (arr, count) => {
    var temp = [];
    var result = [];
    var k = 0;
    for (var i = 0; i < arr.length; ++i) {
        if (i % count == 0) {
            temp = [];
            for (var j = 0; j < count; ++j) {
                if (arr[i + j] == undefined) {
                    continue;
                }
                else {
                    temp[j] = arr[i + j];
                }
            }
            result[k] = temp;
            k++;
        }
    }
    return result;
};
export const RightIcon = (props) => {
    const { fillColor1, fillColor2 } = props;
    return (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M7 3H9.33333L13 8L9.33333 13H7L10.6667 8L7 3Z", fill: fillColor1 }),
        React.createElement("path", { d: "M2 3H4.33333L8 8L4.33333 13H2L5.66667 8L2 3Z", fill: fillColor2 })));
};
export const MustDeleteIcon = () => {
    return (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z", fill: "#FE5B4C" }),
        React.createElement("path", { d: "M5.70044 5.7002L10.3 10.2997M10.2995 5.7002L5.69995 10.2997", stroke: "white", "stroke-linecap": "round" })));
};
export const CanDeleteIcon = () => {
    return (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("circle", { cx: "8", cy: "8", r: "7", fill: "#FFB54C" }),
        React.createElement("path", { d: "M8 4.7002V9.00018", stroke: "white", "stroke-linecap": "round" }),
        React.createElement("path", { d: "M8.60002 11.1C8.60002 11.4314 8.3314 11.7 8.00002 11.7C7.66865 11.7 7.40002 11.4314 7.40002 11.1C7.40002 10.7686 7.66865 10.5 8.00002 10.5C8.3314 10.5 8.60002 10.7686 8.60002 11.1Z", fill: "white" })));
};
export const SuggestKeepIcon = () => {
    return (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("circle", { cx: "8", cy: "8", r: "7", fill: "#0FD683" }),
        React.createElement("path", { d: "M5.30005 8L7.42137 10.1213C7.42137 10.1213 9.74027 7.80242 11.3105 6.23223", stroke: "white", "stroke-linecap": "round", "stroke-linejoin": "round" })));
};
export const MaximizeIcon = () => {
    return (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M7 3H3V7", stroke: "#8D92A1", "stroke-linecap": "round", "stroke-linejoin": "round" }),
        React.createElement("path", { d: "M3.5 3.5L7 7", stroke: "#8D92A1", "stroke-linecap": "round" }),
        React.createElement("path", { d: "M13 9V13H9", stroke: "#8D92A1", "stroke-linecap": "round", "stroke-linejoin": "round" }),
        React.createElement("path", { d: "M12.5 12.5L9 9", stroke: "#8D92A1", "stroke-linecap": "round" })));
};
export const HandleMethodsMap = {
    1: {
        label: getIn18Text('ZHIJIEQINGCHU'),
        icon: React.createElement(MustDeleteIcon, null),
    },
    2: {
        label: getIn18Text('JIANYIQINGCHU'),
        icon: React.createElement(CanDeleteIcon, null),
    },
    3: {
        label: getIn18Text('JIANYIBAOLIU'),
        icon: React.createElement(SuggestKeepIcon, null),
    },
};
export const FilterStrategy = [
    {
        name: getIn18Text('YICHANG(WUXIAO)'),
        strategy: [InvalidStatusMap[103], InvalidStatusMap[3], InvalidStatusMap[7], InvalidStatusMap[105]],
    },
    {
        name: getIn18Text('YICHANGZHUANGTAI'),
        strategy: [InvalidStatusMap[2], InvalidStatusMap[4], TypesMap.hasReturn, TypesMap.emailUnknown],
    },
    {
        name: getIn18Text('TESHUYOUXIANG'),
        strategy: [TypesMap.governmentOrgans, TypesMap.enterpriseMailbox, TypesMap.academicInstitution],
    },
    {
        name: getIn18Text('ZHONGFUFAXIN'),
        type: 'DuplicateEmail',
        items: [
            {
                title: getIn18Text('WO'),
                strategy: [TypesMap.sendIn24h, TypesMap.sendIn72h, TypesMap.hasReply, TypesMap.sendIn1Week, TypesMap.sendIn1Month, TypesMap.hasSend],
            },
            {
                title: getIn18Text('colleague'),
                strategy: [
                    TypesMap.colleagueSendIn24h,
                    TypesMap.colleagueSendIn72h,
                    TypesMap.colleagueHasReply,
                    TypesMap.colleagueSendIn1Week,
                    TypesMap.colleagueSendIn1Month,
                    TypesMap.colleagueHasSend,
                ],
            },
        ],
        strategy: [TypesMap.sendIn24h, TypesMap.sendIn72h, TypesMap.hasReply, TypesMap.sendIn1Week, TypesMap.sendIn1Month, TypesMap.hasSend],
    },
    {
        name: getIn18Text('CRMKEHU'),
        subTitle: getIn18Text('（SHOUJIANRENCHAOGUO1'),
        type: 'CRM',
        strategy: [TypesMap.myCustomer, TypesMap.myClue, TypesMap.colleagueCustomer, TypesMap.colleagueClue],
    },
];
const beginAndEndTime = {
    begin: 0,
    end: 0,
    reduceTime: 0,
};
export const TrackTime = {
    totalTime: cloneDeep(beginAndEndTime),
    v2Time: cloneDeep(beginAndEndTime),
    checkTime: cloneDeep(beginAndEndTime),
};
export const v2InvalidCode = [2, 3, 7];
export const checkInvalidCode = [100, 103, 104, 105];
const invalidAddress = [28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39];
export const AllInvalidStatusCode = v2InvalidCode.concat(checkInvalidCode, invalidAddress);
export const getIdToValueData = () => {
    const idToValueMap = new Map();
    const idToLabelMap = new Map();
    const idToPriorityMap = new Map();
    const idToHandleMethodMap = new Map();
    const allParentList = [];
    for (const key in TypesMap) {
        const value = TypesMap[key];
        const valuePriority = (value.priority || '') + '';
        idToValueMap.set(value.id, key);
        idToLabelMap.set(value.id, value.label);
        idToPriorityMap.set(value.id, valuePriority);
        idToHandleMethodMap.set(value.id, value.type);
        allParentList.push(value);
    }
    allParentList.push({
        label: getIn18Text('QIANGZHIQINGCHUHEIMINGDAN'),
        value: 'forceBlacklist',
        id: 17,
        type: 1,
        priority: 1,
    });
    allParentList.push({
        label: getIn18Text('CUOWUYOUXDZ'),
        value: 'errorAddresslist',
        id: 18,
        type: 1,
        priority: 1,
    });
    allParentList.push({
        label: getIn18Text('GUANLIYUANSZTSKHFCTG1'),
        value: 'forceColleaugeCustomerList',
        id: 19,
        type: 1,
        priority: 1,
    });
    allParentList.push({
        label: getIn18Text('GUANLIYUANSZTSXSFCTG1'),
        id: 20,
        value: 'forceColleaugeClueList',
        type: 1,
        priority: 2,
    });
    for (const key in InvalidStatusMap) {
        const valuePriority = (InvalidStatusMap[key].priority || '') + '';
        idToLabelMap.set(parseInt(key), InvalidStatusMap[key].label);
        idToPriorityMap.set(parseInt(key), valuePriority);
        idToValueMap.set(parseInt(key), InvalidStatusMap[key].value);
    }
    return {
        idToValueMap,
        idToLabelMap,
        idToPriorityMap,
        idToHandleMethodMap,
        allParentList,
    };
};
export const EmailOtherStatusList = [1, 2, 6, 7, 8];
export const EmailVerifyOtherMap = {
    6: 'enterpriseMailbox',
    7: 'governmentOrgans',
    8: 'academicInstitution',
    2: 'emailUnknown',
};
